import script from "./PayrollScheduleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollScheduleManagement.vue?vue&type=script&setup=true&lang=js"

import "./PayrollScheduleManagement.vue?vue&type=style&index=0&id=36d31d6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d31d6b"]])

export default __exports__